
export function urlsError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.isOK = false
}

export function setIsOk(state,payload){
    state.isOk = payload
}
export function setUrls(state,payload){
    state.urls = payload.data.urls
}